'use strict';

var oktaService = require('../services/okta.service.js');

var REACT_REDIRECT_STATES = {
  search: true,
  'queue.qa': true,
  'queue.post-prod': true,
  detail: true,
  admin: true,
};

function mergeRouteParams(toParams, locationSearch) {
  var merged = {};
  var key;

  for (key in toParams) {
    if (toParams[key] != null && toParams[key] !== '') {
      merged[key] = toParams[key];
    }
  }

  for (key in locationSearch) {
    if (locationSearch[key] != null && locationSearch[key] !== '') {
      merged[key] = locationSearch[key];
    }
  }

  return merged;
}

function buildLegacyUrl($state, $window, stateName, toParams, locationSearch) {
  var href = $state.href(stateName, mergeRouteParams(toParams, locationSearch));

  if (href.charAt(0) !== '#') {
    href = '#' + href;
  }

  return $window.location.origin + $window.location.pathname + href;
}

function buildRedirectToReactParams(
  $state,
  $window,
  stateName,
  toParams,
  locationSearch
) {
  var params = { target: stateName };

  if (stateName === 'search' && toParams.q) {
    params.q = toParams.q;
  } else if (stateName === 'admin') {
    params.section = toParams.section;
  } else if (stateName === 'detail') {
    params.productIdentifier = toParams.productIdentifier;
    if (toParams.jobId) {
      params.jobId = toParams.jobId;
    }
  } else if (stateName === 'queue.qa' && locationSearch.tab) {
    params.tab = locationSearch.tab;
  }

  params.from = buildLegacyUrl(
    $state,
    $window,
    stateName,
    toParams,
    locationSearch
  );

  return params;
}

var RouteChange = /*@ngInject*/ function (
  $rootScope,
  $window,
  AUTH_EVENTS,
  AuthService,
  $timeout,
  $state,
  $location,
  localStorageService,
  FeatureFlagService
) {
  $rootScope.$on('$stateChangeStart', function (event, next, toParams) {
    var authorizedRoles = null;

    if (next.data) {
      authorizedRoles = Object.keys(next.data.authorizedRoles);
    }

    if (!AuthService.isAuthorized(authorizedRoles)) {
      event.preventDefault();
      if (
        !FeatureFlagService.isEnabled('global-search-v2-nav') &&
        next.name === 'search'
      ) {
        var landingPage = AuthService.getUsersLandingPage();
        if (landingPage) {
          $state.go(landingPage);
          return;
        }
      }
      $rootScope.$broadcast(AUTH_EVENTS.notAuthorized);
      return;
    }

    if (REACT_REDIRECT_STATES[next.name]) {
      event.preventDefault();
      $state.go(
        'redirect-to-react',
        buildRedirectToReactParams(
          $state,
          $window,
          next.name,
          toParams,
          $location.search()
        ),
        { location: 'replace' }
      );
      return;
    }

    var preRedirect = localStorageService.get('pre-redirect');
    if (preRedirect > '') {
      event.preventDefault();
      localStorageService.remove('pre-redirect');
      $window.location.assign(preRedirect);
    }

    if (next.pageTitle) {
      $timeout(function () {
        document.title = next.pageTitle;
      }, 0);
    }
  });
};

module.exports = RouteChange;
